'use es6';

import ShareDeliveryFrequencySelect from './ShareDeliveryFrequencySelect';
import ShareScheduleDayPickerSelect from './ShareScheduleDayPickerSelect';
import ShareScheduleTimePickerSelect from './ShareScheduleTimePickerSelect';
import ShareScheduleSummary from './ShareScheduleSummary';
import { useControlsContext } from '../context';
import { SCHEDULE_FREQUENCY } from '../../../lib/schedulingLogic';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ShareScheduling = () => {
  const {
    shareScheduleFrequency
  } = useControlsContext();
  const shouldRenderDayPicker = shareScheduleFrequency === SCHEDULE_FREQUENCY.WEEKLY || shareScheduleFrequency === SCHEDULE_FREQUENCY.MONTHLY;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ShareDeliveryFrequencySelect, {}), shouldRenderDayPicker && /*#__PURE__*/_jsx(ShareScheduleDayPickerSelect, {}), /*#__PURE__*/_jsx(ShareScheduleTimePickerSelect, {}), /*#__PURE__*/_jsx(ShareScheduleSummary, {})]
  });
};
export default ShareScheduling;